import React from 'react'
export default function TrainingResult({ data }) {
  return (
    <section className="training-result">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-12 col-lg-8">
            <div className="result-text">
              <h3 className="heading heading-gap">{data?.heading}</h3>
              <p>{data?.description}</p>
            </div>
          </div>
        </div>
        <div className="row">
          {data?.items?.map((item, index) => (
            <div className="col-md-6" key={index}>
              <div className="training-col">
                <img src={item?.image} alt="Icon" className="img-responsive" />
                <h3 className="heading">{item?.title}</h3>
                <p>{item?.text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}